/* app/js/src/components/blocks/edit-block-header/edit-block-header.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.shows-counter {
  transform: scale(0.8);
  position: relative;
  top: 16px;
}
.shows-counter div {
  position: absolute;
  min-width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 3px solid white;
  text-align: center;
  line-height: 34px;
  font-size: 30px;
}
.shows-counter .counter {
  background-color: white;
  margin-left: 15px;
  margin-top: -15px;
  color: #2dbbfc;
}
[contenteditable] {
  outline: 0px solid transparent;
}
.container {
  color: white;
  padding-top: 20px;
  padding-bottom: 20px;
}
.container .block-icon {
  width: 10%;
}
.container .name-editor {
  width: 20%;
}
.container .duration {
  width: 20%;
  justify-content: center;
  padding-left: 5%;
}
.container .actions {
  width: 50%;
  text-align: right;
  line-height: 60px;
  margin-right: 50px;
}
.container .actions remove-button,
.container .actions evrideo-copy-button {
  width: 20px;
  transform: scale(1.5);
}
.container .actions .action {
  margin-right: 30px;
}
.container .field {
  font-size: 25px;
}
.container .field.text-editor {
  border-bottom: 1px solid white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.container .field.title {
  font-size: 10px;
  font-weight: 700;
  padding-top: 5px;
}
/*# sourceMappingURL=edit-block-header.component.css.map */
